import { ColorEnum } from '@/constants/color'
import { InputFieldEnum } from '@/features/ui/inputs/components/InputField/constants'
import { RefObject } from 'react'
import { TextInput } from 'react-native'

export const getPlaceholderColor = (state: InputFieldEnum) => {
    if (state === InputFieldEnum.Disabled) return ColorEnum.GRAY_400

    if (state === InputFieldEnum.Error) return ColorEnum.BRICK_500

    if (state === InputFieldEnum.Hovered) return ColorEnum.GRAY_600

    return ColorEnum.GRAY_300
}

export const handleContainerPress = (textInputRef: RefObject<TextInput | null>) => {
    if (!textInputRef.current) return

    textInputRef.current.focus()
}
